/* Mailchimp newsletter signup.
   list-manage.com sends no CORS headers, so fetch() can never read a response —
   Mailchimp's post-json endpoint answers over JSONP instead. We drive the same
   .loading/.success/.error classes Ghost's members script sets, so these forms
   inherit the theme's existing styling untouched. */
(function () {
    const forms = document.querySelectorAll('form[data-ff-mailchimp]');
    if (!forms.length) return;

    const TIMEOUT = 10000;

    /* Mailchimp's spam trap: a field named b_<u>_<id>, parked off-screen, that only
       a bot would fill in. Both values are already in the form's action URL. */
    function addHoneypot(form) {
        const params = new URLSearchParams(form.action.split('?')[1] || '');
        const u = params.get('u');
        const id = params.get('id');
        if (!u || !id) return;

        const wrap = document.createElement('div');
        wrap.setAttribute('aria-hidden', 'true');
        wrap.style.cssText = 'position:absolute;left:-5000px';

        const input = document.createElement('input');
        input.type = 'text';
        input.name = 'b_' + u + '_' + id;
        input.tabIndex = -1;
        input.autocomplete = 'off';
        input.value = '';

        wrap.appendChild(input);
        form.appendChild(wrap);
    }

    function jsonp(url, done) {
        const callback = 'ffMailchimp' + Math.random().toString(36).slice(2);
        const script = document.createElement('script');
        let settled = false;

        function finish(err, data) {
            if (settled) return;
            settled = true;
            delete window[callback];
            script.remove();
            done(err, data);
        }

        window[callback] = function (data) {
            finish(null, data);
        };
        script.onerror = function () {
            finish(new Error('Mailchimp request failed'));
        };

        script.src = url + '&c=' + callback;
        document.body.appendChild(script);
        window.setTimeout(function () {
            finish(new Error('Mailchimp request timed out'));
        }, TIMEOUT);
    }

    /* Mailchimp returns messages as HTML, prefixed with the index of the offending
       field ("0 - "). Strip both. The already-subscribed case gets our own copy,
       because Mailchimp's version embeds a link back to its hosted form. */
    function readMessage(form, data) {
        const raw = String((data && data.msg) || '');
        if (/already subscribed/i.test(raw)) return form.dataset.ffMcExists;

        const el = document.createElement('div');
        el.innerHTML = raw.replace(/^\d+\s*-\s*/, '');
        return (el.textContent || '').trim() || form.dataset.ffMcError;
    }

    /* Lets the homepage band stay hidden on later visits. Functional only - no
       identifier, no tracking. Skips `secure` off https so local dev still works. */
    function rememberSignup() {
        document.cookie = 'ff_subscribed=1; path=/; max-age=31536000; samesite=lax' +
            (window.location.protocol === 'https:' ? '; secure' : '');
    }

    forms.forEach(function (form) {
        const error = form.querySelector('[data-members-error]');
        addHoneypot(form);

        form.addEventListener('submit', function (event) {
            event.preventDefault();
            if (form.classList.contains('loading')) return;

            form.classList.remove('error', 'success');
            form.classList.add('loading');
            if (error) error.textContent = '';

            const params = new URLSearchParams(new FormData(form));
            const endpoint = form.action.replace('/post?', '/post-json?');

            jsonp(endpoint + '&' + params.toString(), function (err, data) {
                form.classList.remove('loading');

                if (!err && data && data.result === 'success') {
                    form.classList.add('success');
                    rememberSignup();
                    return;
                }

                form.classList.add('error');
                if (error) {
                    error.textContent = err ? form.dataset.ffMcError : readMessage(form, data);
                }
            });
        });
    });
})();
